<main class="pb-0">
  <section
    class="py-5"
    style="
      background-image: url('assets/images/login-background.jpg');
      background-size: cover;
    "
  >
    <div class="container px-4 py-5">
      <div class="row align-items-stretch g-0">
        <div class="col-md-10 mx-auto col-lg-8 shadow">
          <div class="p-4 p-md-5 shadow bg-light h-100">
            <h1 class="display-6">Reset Password</h1>
            <small class="fw-semibold">
              Enter new password and confirm below
            </small>
            <div *ngIf="!submitted">
              <form [formGroup]="form" (ngSubmit)="onSubmit()">
                <div class="form-group">
                  <label for="password" class="col-md-2 control-label">
                    New Password
                  </label>
                  <div class="col-md-10">
                    <input
                      type="password"
                      formControlName="password"
                      class="form-control"
                      id="password"
                      autocomplete="new-password"
                    />
                    <div
                      *ngIf="
                        form.controls['password'].invalid &&
                        form.controls['password'].touched
                      "
                      class="text-danger"
                    >
                      <span *ngIf="form.controls['password'].errors?.['required']">
                        The password field is required.
                      </span>
                      <span *ngIf="form.controls['password'].errors?.['pattern']">
                        Passwords must contain between 12 and 20 characters,
                        both lower and uppercase letters, and at least one
                        number or special character.
                      </span>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label for="confirmPassword" class="col-md-2 control-label">
                    Confirm Password
                  </label>
                  <div class="col-md-10">
                    <input
                      type="password"
                      formControlName="confirmPassword"
                      class="form-control"
                      id="confirmPassword"
                      autocomplete="new-password"
                    />
                    <div
                      *ngIf="
                        form.controls['confirmPassword'].invalid &&
                        form.controls['confirmPassword'].touched
                      "
                      class="text-danger"
                    >
                      The confirm password field is required.
                    </div>
                    <div *ngIf="passwordMismatch" class="text-danger">
                      Passwords do not match.
                    </div>
                  </div>
                </div>
                <br />
                <div class="form-group">
                  <div class="offset-md-2 col-md-10">
                    <button type="submit" class="btn btn-primary">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
            <div *ngIf="errorMessage" class="text-danger mt-3">
              <p>{{ errorMessage }}</p>
            </div>
            <div *ngIf="submitted" class="text-success mt-3">
              <p>
                Your password has been reset. Please log in with your new
                password. You will be redirected to the Login page.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>
